import React, {useEffect, useState} from 'react'
import {deleteWarehouse} from "../../services/serviceWarehouse";
import {Button, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const WarehouseDelete = ({warehouse, updater}) => {

    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDisabled, setDeleteDisabled] = useState(false)
    const [loadings, setLoadings] = useState([])


    useEffect(() => {
        setDeleteDisabled(warehouse.warehouseCode.toLocaleLowerCase() === 'şerifali')
    }, [warehouse])

    const handleDeleteClick = (decision) => {
        if (decision){
            enterLoadingState(setLoadings)
            deleteWarehouse(warehouse.id)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setDeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }else{
            setDeleteModal(!deleteModal)
        }
    }

    return(
        <React.Fragment>
            <Button type={'link'} danger disabled={deleteDisabled} onClick={()=>setDeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                onCancel={() => setDeleteModal(!deleteModal)}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button type={'primary'} danger key={'submitButton'} loading={loadings[0]} onClick={()=> handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>

        </React.Fragment>
    )
}
export default WarehouseDelete